/**
 * 安全防护模块 — 生产环境禁用开发者工具
 *
 * 环境判定（当前策略）：
 *   - hostname 是 localhost / 127.0.0.1 / 局域网 IP / *.local → 开发环境，不启用；
 *   - hostname 是域名（含内网域名）→ 视为正式环境，默认启用。
 *
 * 正式环境下默认做三件事：
 *   1. 屏蔽 F12 / Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C / Ctrl+U 等快捷键；
 *   2. 定时检测 DevTools 是否打开，一旦打开就持续触发 debugger 断点，使页面停在断点处；
 *   3. 右键菜单默认不拦截（避免影响业务用户的复制粘贴习惯），需要时可通过配置打开。
 *
 * 使用方式：
 *   ttx.security.isProduction();          // 是否正式环境
 *   ttx.security.isDevtoolsOpen();        // 当前 DevTools 是否打开
 *   ttx.security.stop();                  // 临时关闭（如内部演示）
 *   ttx.security.start();                 // 重新开启
 *   ttx.security.config({                 // 改配置（运行中立即生效）
 *       enabled: false,                   // false 强制关闭 / true 强制开启（开发环境也开）
 *       blockShortcuts: true,
 *       blockContextMenu: false,
 *       devtoolsGuard: true,
 *       guardInterval: 1000,              // 未打开 DevTools 时的检测间隔（ms）
 *       onDevtoolsOpen: function () {}    // 自定义处理（配置后不再触发 debugger）
 *   });
 *
 * 逃生开关（需在 SDK 加载前设置）：window.__TTX_SECURITY_DISABLED__ = true
 */
window.ttx = window.ttx || {};
ttx.security = ttx.security || {};

(function () {
    var config = {
        // null=自动判断（域名即生产）；true=强制开启；false=强制关闭
        enabled: null,
        blockShortcuts: true,
        // 右键菜单默认不拦截，需要时再打开
        blockContextMenu: false,
        devtoolsGuard: true,
        guardInterval: 1000,
        // 自定义 DevTools 打开后的处理；不设置时使用 debugger 断点卡住页面
        onDevtoolsOpen: null
    };

    var _started = false;
    var _timer = null;
    var _keyHandler = null;
    var _contextHandler = null;

    // ============================================================
    // 环境判断
    // ============================================================

    /** 是否 IPv4 / IPv6 地址 */
    function isIpHost(host) {
        return /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || host.indexOf(':') >= 0;
    }

    /**
     * 是否正式环境：hostname 是域名即视为正式环境。
     * 开发环境（localhost / IP / *.local）返回 false。
     */
    ttx.security.isProduction = function () {
        var host = (window.location.hostname || '').toLowerCase();
        if (!host) return false;
        if (host === 'localhost' || host === '0.0.0.0') return false;
        if (host.slice(-6) === '.local') return false;
        if (isIpHost(host)) return false;
        return true;
    };

    // ============================================================
    // DevTools 检测
    // ============================================================

    /**
     * DevTools 是否打开：利用 debugger 语句在被调试时会被断住的特性，
     * 通过耗时判断是否处于调试状态（不依赖窗口尺寸，停靠/浮动都适用）。
     */
    ttx.security.isDevtoolsOpen = function () {
        try {
            var start = performance.now();
            // eslint-disable-next-line no-debugger
            debugger;
            return performance.now() - start > 100;
        } catch (e) {
            return false;
        }
    };

    // ============================================================
    // 拦截逻辑
    // ============================================================

    function blockEvent(e) {
        if (!e) return;
        e.preventDefault();
        e.stopPropagation();
    }

    /** 屏蔽 F12 / Ctrl+Shift+I/J/C / Ctrl+U */
    function onKeyDown(e) {
        var key = e.key || '';
        var ctrl = e.ctrlKey || e.metaKey;
        var shift = e.shiftKey;
        if (key === 'F12') return blockEvent(e);
        if (ctrl && shift && /^(I|J|C)$/i.test(key)) return blockEvent(e);
        if (ctrl && /^U$/i.test(key)) return blockEvent(e);
    }

    /** 屏蔽右键菜单 */
    function onContextMenu(e) {
        blockEvent(e);
    }

    /** DevTools 打开后的处理：默认持续断点，让页面卡住 */
    function handleDevtoolsOpen() {
        if (typeof config.onDevtoolsOpen === 'function') {
            try { config.onDevtoolsOpen(); } catch (e) { /* 自定义处理异常不影响主流程 */ }
            return;
        }
        // eslint-disable-next-line no-debugger
        debugger;
        // 已打开时高频复查，避免用户关掉断点后继续操作
        _timer = setTimeout(guardLoop, 200);
    }

    /** 检测循环：未打开时按 guardInterval 轮询，打开后触发拦截 */
    function guardLoop() {
        if (!_started) return;
        _timer = null;
        if (ttx.security.isDevtoolsOpen()) {
            handleDevtoolsOpen();
            return;
        }
        _timer = setTimeout(guardLoop, config.guardInterval);
    }

    function scheduleGuard() {
        if (_timer) {
            clearTimeout(_timer);
            _timer = null;
        }
        _timer = setTimeout(guardLoop, config.guardInterval);
    }

    // ============================================================
    // 启停与配置
    // ============================================================

    /** 开启防护（传 options 等价于先 config 再 start） */
    ttx.security.start = function (options) {
        if (options) ttx.security.config(options);
        var enabled = config.enabled;
        if (enabled === false) return false;
        // 未显式开启时按环境自动判断：仅正式环境启用
        if (enabled !== true && !ttx.security.isProduction()) return false;
        if (_started) return true;

        _started = true;
        if (config.blockShortcuts && !_keyHandler) {
            _keyHandler = onKeyDown;
            document.addEventListener('keydown', _keyHandler, true);
        }
        if (config.blockContextMenu && !_contextHandler) {
            _contextHandler = onContextMenu;
            document.addEventListener('contextmenu', _contextHandler, true);
        }
        if (config.devtoolsGuard) scheduleGuard();
        return true;
    };

    /** 关闭防护（解除全部监听） */
    ttx.security.stop = function () {
        _started = false;
        if (_timer) {
            clearTimeout(_timer);
            _timer = null;
        }
        if (_keyHandler) {
            document.removeEventListener('keydown', _keyHandler, true);
            _keyHandler = null;
        }
        if (_contextHandler) {
            document.removeEventListener('contextmenu', _contextHandler, true);
            _contextHandler = null;
        }
    };

    /** 修改配置，运行中调用会立即按新配置重启防护 */
    ttx.security.config = function (options) {
        var next = options || {};
        for (var key in next) {
            if (Object.prototype.hasOwnProperty.call(next, key) && config.hasOwnProperty(key)) {
                config[key] = next[key];
            }
        }
        if (_started) {
            ttx.security.stop();
            ttx.security.start();
        }
        return config;
    };

    /** 当前是否已启用防护 */
    ttx.security.isStarted = function () {
        return _started;
    };

    // ============================================================
    // 自动初始化
    // ============================================================

    function autoInit() {
        if (window.__TTX_SECURITY_DISABLED__) return;
        ttx.security.start();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoInit);
    } else {
        autoInit();
    }
})();
